// VoK MUI base styles
import typography from "app/assets/theme/base/typography";
import borders from "app/assets/theme/base/borders";
import colors from "app/assets/theme/base/colors";

// VoK MUI helper functions
import pxToRem from "app/assets/theme/functions/pxToRem";

const {size, fontWeightRegular} = typography;
const {borderRadius} = borders;
const {dark} = colors;

const tab = {
    styleOverrides: {
        root: {
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            flex: "1 1 auto",
            textAlign: "center",
            maxWidth: "unset !important",
            minWidth: "unset !important",
            minHeight: "unset !important",
            fontSize: size.md,
            fontWeight: fontWeightRegular,
            textTransform: "none",
            lineHeight: "inherit",
            padding: pxToRem(4),
            borderRadius: borderRadius.md,
            color: `${dark.main} !important`,
            opacity: "1 !important",

            "& .material-icons, .material-icons-round": {
                marginBottom: "0 !important",
                marginRight: pxToRem(4),
            },

            "& svg": {
                marginBottom: "0 !important",
                marginRight: pxToRem(6),
            },
        },

        labelIcon: {
            paddingTop: pxToRem(4),
        },
    },
};

export default tab;
